<photo *ngFor="let item of items; let imageNum = index" (click)="openLightbox(imageNum)" [src]="item.thumbnail"></photo>
